import $ from 'jquery'

//-------- Ajax Wrapper --------
export {
    ajaxWrapper
}

function ajaxWrapper(arg) {

    var opt = $.extend({}, $.ajaxSettings, arg);
    var jqXHR = $.ajax(opt);
    var defer = $.Deferred();

    jqXHR.done(function (data, statusText, jqXHR) {
        defer.resolveWith(this, arguments);
    });

    jqXHR.fail(function (jqXHR, statusText, errorThrown) {
        defer.rejectWith(this, arguments);
    });

    jqXHR.always(function () {
        errorHandling(jqXHR);
    });

    return $.extend({}, jqXHR, defer.promise());
}

function errorHandling(jqXHR) {

    var errorPath = "/error";
    switch (jqXHR.status) {
        case 401:
            window.location.href = errorPath;
            break;
        case 403:
            window.location.href = errorPath;
            break;
        case 500:
            window.location.href = errorPath;
            break;
        default:
            break;
    }
}
